// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1u9Eb","productName":"Table_productName__1ZLy9"};